import { useEffect, useRef } from 'react';

type Props = {
  srcDesktop: string;
  srcMobile: string;
  poster: string;
  label: string;
};

// Full-bleed background clip (real pipeline output). The poster renders first; the video
// source is chosen on the client by viewport width and skipped for reduced-motion or data-saver.
export default function HeroVideo({ srcDesktop, srcMobile, poster, label }: Props) {
  const ref = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    const video = ref.current;
    if (!video) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = (navigator as Navigator & { connection?: { saveData?: boolean } }).connection?.saveData === true;
    if (reduced || saveData) return;
    video.src = window.innerWidth >= 768 ? srcDesktop : srcMobile;
    video.play().catch(() => undefined);
  }, [srcDesktop, srcMobile]);
  return (
    <>
      <img src={poster} alt={label} className="absolute inset-0 h-full w-full object-cover object-center" loading="eager" fetchPriority="high" />
      <video
        ref={ref}
        className="absolute inset-0 h-full w-full object-cover object-center"
        poster={poster}
        muted
        loop
        playsInline
        preload="none"
        aria-hidden="true"
        tabIndex={-1}
      />
    </>
  );
}
